import React from 'react';

import styles from "../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import {AthleteWidgetEntityPlaceholder} from "./athlete-widget.entity.placeholder";

export const AthleteWidgetHeaderPlaceholder = ({device}) => {
  const {isSmallView} = device;

  const entityProps = {
    device,
    imageSize: isSmallView ? 64 : 80,
    textTopMargin: isSmallView ? 4 : 16,
    imageMarginTop: 0
  }

  return (
    <PlaceholderWrapperComponent className={classNames(styles.header, {[styles.small_view]: isSmallView})}>
      <AthleteWidgetEntityPlaceholder {...entityProps}/>
    </PlaceholderWrapperComponent>
  )
}
